/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  preview(id) {
    return axios.post(`${this.url}/${id}/preview`);
  }

  launch(id) {
    return axios.post(`${this.url}/${id}/launch`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  report(id) {
    return axios.get(`${this.url}/${id}/report`);
  }

  recipients(id, { page = 1, status = '' } = {}) {
    return axios.get(`${this.url}/${id}/recipients`, {
      params: { page, status },
    });
  }
}

export default new CampaignsAPI();
